import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import {
  DeleteOutlineOutlined,
  FolderOpenOutlined,
} from '@mui/icons-material'
import { Icon, Load } from 'ui/styled'
import { isModularContentType } from 'utils'
import { buildFavoriteDragId } from '../utils'
import {
  ActionGroup,
  ActionSlot,
  FavoriteListContainer,
  FavoriteListMeta,
  FavoriteListTitle,
  FavoriteListWrapper,
  ItemActionButton,
  ItemActionButton2,
  ItemThumb,
  SelectionInput,
} from './styled'

export default function FavoriteListRow({
  item,
  selected,
  onSelect,
  onOpen,
  onRemove,
  busy,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: buildFavoriteDragId(item.favoriteId),
    data: {
      type: 'item',
      favoriteId: item.favoriteId,
      folderId: item.folderId,
    },
    disabled: busy,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <FavoriteListContainer
      ref={setNodeRef}
      style={style}
      dragging={isDragging}
      selected={selected}
      onClick={() => onOpen(item)}
      {...attributes}
      {...listeners}
    >
      <FavoriteListWrapper>
        <SelectionInput
          type="checkbox"
          checked={selected}
          onClick={(event) => event.stopPropagation()}
          onChange={() => onSelect(item.favoriteId)}
        />
        <ItemThumb src={item?.image?.url || item?.cover || '/images/image.png'} alt={item?.title} />
        <FavoriteListMeta>
          <FavoriteListTitle>{item?.title}</FavoriteListTitle>
        </FavoriteListMeta>
      </FavoriteListWrapper>

      <ActionGroup onClick={(event) => event.stopPropagation()}>
        <ActionSlot>
          <ItemActionButton type="button" onClick={() => onRemove(item.favoriteId)} disabled={busy}>
            {busy ? <Load /> : <DeleteOutlineOutlined fontSize="small" />}
          </ItemActionButton>
        </ActionSlot>
        <ActionSlot>
          <ItemActionButton2 type="button" onClick={() => onOpen(item)}>
            {isModularContentType(item?.type)
              ? <FolderOpenOutlined fontSize="small" />
              : <Icon icon="download" />}
          </ItemActionButton2>
        </ActionSlot>
      </ActionGroup>
    </FavoriteListContainer>
  )
}
